import React, { useEffect, useState } from "react";
import SideMenu from "../../../Components/SideDrawer";
import { Button, Container, Row, Col, Form, Table, Modal } from "react-bootstrap";
import PageHeader from "../../../Components/Header";
import { useNavigate } from "react-router-dom";
import { PencilSquare } from "react-bootstrap-icons";
import { companyGet, employeeSalaryDetailsGet, employeeSalaryPut, DesignationGet, employeeGet } from "../../../Api/Admin/AdminApi";
import { extractErrorMessage } from "../../../Utils/ErrorUtlis";

const EmployeePayView = () => {
  const [apiData, setApiData] = useState([]);
  const [organizations, setOrganizations] = useState([]);
  const [employeeData, setEmployeeData] = useState([]);
  const [designationData, setdesignationData] = useState([]);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [loadingCompany, setLoadingComapany] = useState(true);
  const [isLoading, setIsLoading] = useState(true);
  const [showmodal, setShowModal] = useState(false);
  const [selectedEmployeeDesignation, setSelectedEmployeeDesignation] = useState('')
  const [formdata, setFormData] = useState({
    company_id: null
  });
  const [editFormData, setEditFormData] = useState({
    company_id: null,
    emp_id: '',
    design_id: null,
    Basic_Pay: null,
    Attendance_allowance: null,
    Overtime_pay: null,
    allowences: null,
    incentives: null,
    CPF: null,
    payment_mode: ''
  });
  const navigate = useNavigate();

  useEffect(() => {
    const fetchCompany = async () => {
      try {
        const data = await companyGet();
        if (data) {
          const companies = data.map(i => ({
            id: i._id,
            name: i.name,
          }));
          setOrganizations(companies);
          setLoadingComapany(false)
        } else {
          console.log('No Organization data to fetch');
          alert('No data to Fetch');
        }

      } catch (err) {
        const errorMessage = extractErrorMessage(err)
        console.log('Error Fetching Data in Organization: ', errorMessage || err);
        alert(errorMessage)
      }
    }

    const fetchDesignation = async () => {
      try {
        const data = await DesignationGet();
        if (data) {
          const designation = data.map(i => ({
            id: i._id,
            name: i.name,
          }));
          setdesignationData(designation)
        } else {
          console.log('No Designation data to fetch');
          alert('No data to Fetch');
        }

      } catch (err) {
        const errorMessage = extractErrorMessage(err)
        console.log('Error Fetching Data in Organization: ', errorMessage || err);
        alert(errorMessage)
      }
    }
    fetchCompany();
    fetchDesignation()
  }, []);

  useEffect(() => {
    if (editFormData.emp_id && employeeData.length > 0) {
      const selectedEmployee = employeeData.find(emp => emp.emp_id === editFormData.emp_id);
      if (selectedEmployee) {
        setSelectedEmployeeDesignation(selectedEmployee.designation);
        const designation = designationData.find(d => d.name === selectedEmployee.designation);
        if (designation) {
          setFormData(prev => ({
            ...prev,
            design_id: designation.id
          }));
        }
      }
    }
  }, [editFormData.emp_id, employeeData, designationData]);

  const onEmployeedetails = async (id) => {
    try {
      const employees = await employeeGet(id);
      if (employees && employees.result) {
        const emp = employees.result.map(i => ({
          emp_id: i.emp_id,
          emp_name: i.emp_name,
          designation: i.designation
        }));
        setEmployeeData(emp);
        setIsLoading(false);
      }
    } catch (err) {
      setIsLoading(true);
      const errorMessage = extractErrorMessage(err)
      console.log('Error Fetching Data in Organization: ', errorMessage || err);
      alert(errorMessage)
    }
  }

  const handleEdit = (salaryData) => {
    console.log(`Salary Data ${JSON.stringify(salaryData)}`);

    setSelectedEmployee(salaryData.emp_id);
    console.log(`Selected Employee ${selectedEmployee}`);
    setEditFormData({
      company_id: formdata.company_id,
      emp_id: salaryData.emp_id,
      design_id: formdata.design_id,
      Basic_Pay: salaryData.basic_pay,
      Attendance_allowance: salaryData.attendance_allowence,
      Overtime_pay: salaryData.OT_pay,
      allowences: salaryData.allowences,
      incentives: salaryData.incentives,
      CPF: salaryData.CPF,
      payment_mode: salaryData.payment_mode.toString()
    });
    console.log(`Edit Form Data: ${JSON.stringify(editFormData)}`);
    setShowModal(true);
  };

  const handleModalClose = () => {
    setShowModal(false);
    setEditFormData({
      company_id: null,
      emp_id: '',
      design_id: null,
      Basic_Pay: null,
      Attendance_allowance: null,
      Overtime_pay: null,
      allowences: null,
      incentives: null,
    });
  }

  const handleEditSubmit = async () => {
    // setShowModal(false);
    console.log(`Edit Salary Data: ${JSON.stringify(editFormData)}`);
    try {
      const responseData = await employeeSalaryPut(selectedEmployee, editFormData);
      if (responseData) {
        alert('Employee Salary Details Updated Successfully...');
      }
    } catch (err) {
      const errorMessage = extractErrorMessage(err)
      console.log('Error Fetching Data in Organization: ', errorMessage || err);
      alert(errorMessage)
    }
    handleModalClose();
  }

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));

    setEditFormData(prev => ({
      ...prev,
      [name]: value
    }));

    onEmployeedetails(value);
  };

  const handleEditChange = (e) => {
    const { name, value } = e.target;
    setEditFormData(prev => ({
      ...prev,
      [name]: value
    }));
  }

  const handleButton = () => {
    navigate('/addEmployeePay')
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true)
    setApiData([]);
    try {
      const response = await employeeSalaryDetailsGet(formdata);
      if (response && response.results) {
        const salaryList = response.results.map(i => ({
          emp_id: i.emp_id,
          emp_name: i.emp_name,
          Design: i.Design,
          basic_pay: i.basic_pay,
          attendance_allowence: i.attendance_allowence,
          OT_pay: i.OT_pay,
          allowences: i.allowences,
          incentives: i.incentives,
          CPF: i.CPF
        }));
        setApiData(salaryList);
        setIsLoading(false);
      } else {
        setIsLoading(true);
        alert("No Data Available")
      }
    } catch (err) {
      setIsLoading(true);
      const errorMessage = extractErrorMessage(err)
      console.log('Error Fetching Data in Organization: ', errorMessage || err);
      alert(errorMessage)
    }
  }

  return (
    <div>
      <SideMenu />
      <Container fluid style={{
        marginLeft: '255px',
        padding: '0.5px',
        transition: 'margin 0.3s ease',
        width: 'calc(100% - 250px)'
      }}
      >
        <PageHeader title="Employee Salary Details" showButtons={true} />
        <h4 className="mb-4 d-flex justify-content-between align-items-center">
          Salary Pay Details
          <div className="d-flex flex-column align-items-end">
            <Button variant="primary" className="d-flex align-items-center mb-2" onClick={handleButton} style={{ height: '35px' }}>
              Add Details
            </Button>
          </div>
        </h4>
        <Form onSubmit={handleSubmit} className="mt-4 align-items-center">
          <Row className="mb-3">
            <Form.Group as={Col} md="4" controlId="company_id">
              <Form.Label>Organization Name</Form.Label>
              <Form.Select
                name="company_id"
                value={formdata.company_id}
                onChange={handleChange}
                required
              >
                <option>Select Organization</option>
                {loadingCompany ? (
                  <div> Loading....</div>
                ) : (
                  organizations.map(org => (
                    <option key={org.id} value={org.id}>{org.name}</option>
                  ))
                )}
              </Form.Select>
            </Form.Group>
            <Form.Group as={Col} md="4">
              <Button variant="primary" type="submit" className="d-flex align-items-center mb-2" style={{ marginTop: '22px', height: '30px' }}>
                Get Salary
              </Button>
            </Form.Group>
          </Row>
        </Form>
        {isLoading ? <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
          <div role="status">
            <span className="sr-only">No Data to Show</span>
          </div>
        </div> : <div style={{ overflow: 'auto' }}>
          <Table striped hover responsive='sm' size="sm">
            <thead>
              <tr>
                <th className="fs-12">Employee Id</th>
                <th className="fs-12">Employee Name</th>
                <th className="fs-12">Desigination</th>
                <th className="fs-12">Basic Pay</th>
                <th className="fs-12">Attendance Allowence</th>
                <th className="fs-12">Overtime Pay</th>
                <th className="fs-12">Allowences</th>
                <th className="fs-12">Incentives</th>
                <th className="fs-12">CPF</th>
                <th className="fs-12">Action</th>
              </tr>
            </thead>
            <tbody>
              {apiData.map((emp, i) => (
                <tr key={emp.emp_id}>
                  <td className="fs-12">
                    {emp.emp_id}
                  </td>
                  <td className="fs-12">
                    {emp.emp_name}
                  </td>
                  <td className="fs-12">
                    {emp.Design}
                  </td>
                  <td className="fs-12">
                    {emp.basic_pay}
                  </td>
                  <td className="fs-12">
                    {emp.attendance_allowence}
                  </td>
                  <td className="fs-12">
                    {emp.OT_pay}
                  </td>
                  <td className="fs-12">
                    {emp.allowences}
                  </td>
                  <td className="fs-12">
                    {emp.incentives}
                  </td>
                  <td className="fs-12">
                    {emp.CPF}
                  </td>
                  <td className="fs-12">
                    <Button variant="outline-primary" size="sm" onClick={() => handleEdit(emp)}>
                      <PencilSquare />
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
        }
        <Modal show={showmodal} onHide={handleModalClose}>
          <Modal.Header closeButton>
            <Modal.Title>Update Employee Salary Details</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {editFormData && (
              <Form onSubmit={(e) => {
                e.preventDefault();
                handleEditSubmit();
              }}>
                <Form.Group className="md-4" controlId="emp_id">
                  <Form.Label>Employee Name</Form.Label>
                  <Form.Select
                    name="emp_id"
                    value={editFormData.emp_id}
                    required
                    onChange={handleEditChange}
                  >
                    {employeeData.map(empl => (
                      <option key={empl.emp_id} value={empl.emp_id}>{empl.emp_name}</option>
                    ))}
                  </Form.Select>
                </Form.Group>
                <Form.Group className="md-4" controlId="design_id">
                  <Form.Label>Employee Designation</Form.Label>
                  <Form.Select
                    name="design_id"
                    value={editFormData.emp_id}
                    required
                    onChange={handleEditChange}
                    disabled
                  >
                    <option value="">{selectedEmployeeDesignation || 'Select Employee First'}</option>
                    {employeeData.design_id && (
                      <option value={employeeData.design_id}>
                        {selectedEmployeeDesignation}
                      </option>
                    )}
                  </Form.Select>
                </Form.Group>
                <Row style={{ marginTop: '10px' }}>
                  <Form.Group as={Col} md="4" controlId="Basic_Pay">
                    <Form.Label>Basic Pay</Form.Label>
                    <Form.Control
                      type="number"
                      name="Basic_Pay"
                      value={editFormData.Basic_Pay}
                      onChange={handleEditChange}
                      required
                    ></Form.Control>
                  </Form.Group>
                  <Form.Group as={Col} md="4" controlId="Attendance_allowance">
                    <Form.Label style={{ marginLeft: '75px', width: '150px' }}>Attendance Allowance</Form.Label>
                    <Form.Control
                      type="number"
                      name="Attendance_allowance"
                      value={editFormData.Attendance_allowance}
                      onChange={handleEditChange}
                      required
                      style={{ marginLeft: '75px' }}
                    ></Form.Control>
                  </Form.Group>
                </Row>
                <Row>
                  <Form.Group as={Col} md="4" controlId="Overtime_pay">
                    <Form.Label>Overtime Pay</Form.Label>
                    <Form.Control
                      type="number"
                      name="Overtime_pay"
                      value={editFormData.Overtime_pay}
                      onChange={handleEditChange}
                      required
                    ></Form.Control>
                  </Form.Group>
                  <Form.Group as={Col} md="4" controlId="allowences">
                    <Form.Label style={{ marginLeft: '75px' }}>Allowences</Form.Label>
                    <Form.Control
                      type="number"
                      name="allowences"
                      value={editFormData.allowences}
                      onChange={handleEditChange}
                      required
                      style={{ marginLeft: '75px' }}
                    ></Form.Control>
                  </Form.Group>
                </Row>
                <Row>
                  <Form.Group as={Col} md="4" controlId="incentives">
                    <Form.Label>Incentives</Form.Label>
                    <Form.Control
                      type="number"
                      name="incentives"
                      value={editFormData.incentives}
                      onChange={handleEditChange}
                      required
                    ></Form.Control>
                  </Form.Group>
                  <Form.Group as={Col} md="4" controlId="cpf">
                    <Form.Label style={{ marginLeft: '75px' }}>CPF</Form.Label>
                    <Form.Control
                      type="number"
                      name="CPF"
                      value={editFormData.CPF}
                      onChange={handleEditChange}
                      required
                      style={{ marginLeft: '75px' }}
                    ></Form.Control>
                  </Form.Group>
                </Row>
                <Row>
                  <Form.Group as={Col} md="4" controlId="payment_mode">
                    <Form.Label style={{ marginLeft: '75px' }}>Payment Mode</Form.Label>
                    <div className="d-flex align-items-center" style={{ height: '38px' }}>
                      <Form.Check
                        inline
                        label="Bank"
                        type="radio"
                        name="payment_mode"
                        value="1"
                        checked={editFormData.payment_mode === '1'}
                        onChange={handleEditChange}
                        className="me-2"
                      />
                      <Form.Check
                        inline
                        label="Cash"
                        type="radio"
                        name="payment_mode"
                        value="0"
                        checked={editFormData.payment_mode === '0'}
                        onChange={handleEditChange}
                      />
                    </div>
                  </Form.Group>
                </Row>

                <Row className="mb-4 justify-content-center">
                  <Form.Group as={Col} md='4'>
                    <Button type="submit" variant="primary" className="mt-3">
                      Edit Salary
                    </Button>
                  </Form.Group>
                </Row>
              </Form>
            )}
          </Modal.Body>
        </Modal>
      </Container>
    </div>
  )
};

export default EmployeePayView;